import styled from "styled-components";
import { useRef, useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Popconfirm,
  Drawer,
  DatePicker,
  notification,
  Divider,
  Button,
  Dropdown,
  message,
  Space,
  Switch,
  Tooltip,
  Input,
  Radio,
  Checkbox,
  Modal,
  Message,
  Table,
  Upload,
  Select,
  Pagination,
  Tag,
} from "antd";
import {
  DownOutlined,
  UserOutlined,
  CheckOutlined,
  LoadingOutlined,
  PlusOutlined,
  InboxOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import Sidebar from "../../../Components/Backoffice/Sidebar";
import Card from "../../../Components/Backoffice/Card";
import Title from "../../../Components/Backoffice/Title";
import Header from "../../../Components/Backoffice/Header";
import Footer from "../../../Components/Backoffice/Footer";
import axios, { all } from "axios";
import { ReactComponent as IconOk } from "../../../Assets/Images/Backoffice/Ok.svg";
import { ReactComponent as IconUpload } from "../../../Assets/Images/Backoffice/Upload-off.svg";
import { ReactComponent as IconInfo } from "../../../Assets/Images/Backoffice/Notifications/Info.svg";
import { ReactComponent as IconClose } from "../../../Assets/Images/Backoffice/Close.svg";
import { ReactComponent as IconEdit } from "../../../Assets/Images/Backoffice/Edit.svg";
import { ReactComponent as IconCalendar } from "../../../Assets/Images/Backoffice/Calendar.svg";

import { EyeOutlined } from "@ant-design/icons";
import Search from "antd/es/input/Search";

const { TextArea } = Input;
const { Dragger } = Upload;
const { RangePicker } = DatePicker;

const Wrapper = styled.main`
  background-color: #e8e9f3;
  display: grid;
  grid-template-columns: 7.083vw 1fr;
  min-height: 100vh;

  .ant-select-selector, .ant-select {
    height: 45px;
  }

  .ant-upload {
    height: 119px;
  }

  .cta {
    display: block !important;
    font-size: 15px;
    padding: 0 30px !important;
    font-weight: bold;
    height: 45px !important;
    line-height: 18px;

    i { margin: 0 3px; }

    a { text-decoration: none; }
  }

  
  .close-btn {
    border: 1px solid #494D7D !important;
    color: #494D7D !important;
    height: 45px;
    background: transparent !important;
    padding: 0 50px;
  }


  .cta.publish {
    margin-right: 0;

    svg path {
      fill: #FFF;
    }
  }

  .text {
    color: #809fb8;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .btn-descricao {
    margin-top: 10px;
    height: 45px !important;
    padding: 0 15px;
    font-weight: bold;
  }

  .icon-calendar, .icon-edit {
    width: 24px;
  }

  .icon-edit {
    cursor: pointer;
  }

  .cta.publish {
    margin-right: 0;

    svg path {
      fill: #fff;
    }
  }

  .text {
    margin-bottom: 0 !important;
  }

  @media (max-width: 992px) {
  }
`;

const Content = styled.div`
  padding: 1.771vw;
`;

const CardHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  // gap: 60px;
  grid-template-columns: 1fr auto auto;
`;

const CardContent = styled.div`
  margin: 40px 0;
  position: relative;

  table,
  .ant-table-cell p {
    text-align: center;
  }

  table th,
  table li {
    color: #809fb8 !important;
    text-align: center !important;
  }

  .ant-checkbox-checked span.ant-checkbox-inner,
  .ant-checkbox-checked:hover span.ant-checkbox-inner {
    background-color: #1ad598 !important;
    border-color: #1ad598 !important;
  }

  .ant-checkbox:hover span.ant-checkbox-inner,
  .ant-checkbox-wrapper.item__checkbox:hover .ant-checkbox-inner {
    border-color: #1ad598 !important;
  }

  .user-name {
    color: #494d7d;
  }

  .icon-upload {
    cursor: pointer;
    height: 46px;
    width: 46px;
  }

  .user-number {
    border-color: #d9e1e7cc;
    color: #809fb8;
    text-align: center;
  }

  .user-active {
    background-color: #1ad5984d;
    border: none;
    color: #1ad598;
  }

  .user-desactive {
    background-color: #ea3a3d4d;
    border: none;
    color: #ea3a3d;
  }

  .user-disabled {
    background-color: #d9e1e7;
    border: none;
    color: #99b2c6;
  }

  li.ant-pagination-item {
    border: 1px solid #d9e1e7cc;
  }

  li.ant-pagination-item.ant-pagination-item-active {
    background-color: #8688a8;
    border-color: #8688a8;
    color: #ffffff;
  }
`;

const UploadButtonStyle = styled.button`
  background-color: #494d7d;
  border: none;
  color: #ffffff;
  transition: 0.3s ease;
  font-size: 14px;
  height: 40px;
  padding: 4px 15px;
  border-radius: 6px;
  box-shadow: 0 2px 0 rgb(0 0 0 / 2%);

  :hover {
    background-color: #1ad598;
    color: #ffffff !important;
  }
`;

const AlertMesssage = styled.div`
  background: #f1f5f700 0% 0% no-repeat padding-box;
  border: 2px solid #ffffff;
  border-radius: 16px;
  text-align: left;
  letter-spacing: 0px;
  padding: 10px;
  color: #0c1151;
  font-style: italic;
  width: 100%;

  circle {
    fill: #0c1151;
  }

  svg path {
    fill: #fff;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 18px;

  .form {
    place-self: flex-start;
    width: 100%;
  }
`;

const GridCards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;

  .item {
    margin: 0;
    justify-content: space-between;
    display: flex;
  }

  .disabled {
    opacity: 0.7 !important;
  }

  .item__title {
    color: #494d7d;
    letter-spacing: 0px;
    font-size: 18px;
    font-weight: bold;
    line-height: 18px;
    text-align: left;
  }

  .item__text {
    color: #c2c4d4;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
  }

  .card-gallery {
    display: flex !important;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .header-gallery-div {
    display: block;
  }

  .gallery-title {
    display: flex;
    justify-content: space-between;
  }
`;

const ContentFooter = styled.div`
  align-items: center;
  justify-content: flex-end;
  display: flex;
  flex-direction: row;
  margin-top: 18px;

  button {
    display: block !important;
    font-size: 15px;
    font-weight: bold;
    height: 45px;
    line-height: 18px;

    i {
      margin: 0 3px;
    }
  }

  a {
    text-decoration: none;
  }
`;

const Files = styled.section`
  display: flex;
  flex-direction: column;

  h4 {
    text-align: left;
    font: normal normal bold 20px/20px Roboto;
    letter-spacing: 0px;
    color: #050505;
  }

  .text {
    color: #809fb8;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .center {
    text-align: center;
  }

  .cta {
    display: block !important;
    font-size: 15px;
    font-weight: bold;
    height: 45px;
    line-height: 18px;

    i {
      margin: 0 3px;
    }

    a {
      text-decoration: none;
    }
  }

  .cta.publish {
    margin-right: 0;

    svg path {
      fill: #fff;
    }
  }
`;


const ContentHeader = styled.div`
  align-items: center;
  display: grid;
  gap: 22px;
  grid-template-columns: 1fr auto;
`;


var styles = {
  h6_label: {
    color: "#809FB8",
    fontFamily: "Roboto",
    fontSize: "15px",
    marginTop: "1%",
    marginBottom: "0",
  },
  input_class_disabled: {
    marginBottom: "2%",
    borderRadius: "6px",
    height: "45px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    opacity: 0.6,
    pointerEvents: "none",
  },
  input_class: {
    borderRadius: "6px",
    height: "45px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    width: "100%",
  },
  textarea_class: {
    borderRadius: "6px",
    border: "1px solid #809FB8",
    color: "#0C1151",
  },
  switch_label: {
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: "bold",
    height: "45px",
    borderRadius: "8px",
    padding: "0px 16px",
    color: "#809FB8",
    border: "1px solid #809FB8",
    textAlign: "center",
  },
  upload: {
    width: "100%",
  },
};

export default function DashboardFicheiros() {

  document.title = 'SPAP - Estatutos e Documentos';

  const session_storage = JSON.parse(localStorage.getItem("session_data"));

  const [fileUploadList, setFileUploadList] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [tituloPDF, setTituloPDF] = useState("");
  const [descricaoPDF, setDescricaoPDF] = useState("");
  const [showPDFDrawer, setShowPDFDrawer] = useState(false);
  const [pdfFileEdit, setPDFFileEdit] = useState("");
  const [tituloPDFEdit, setTituloPDFEdit] = useState("");
  const [descricaoPDFEdit, setDescricaoPDFEdit] = useState("");
  const [tipoDocEdit, setTipoDocEdit] = useState("");
  const [removePDFModalOpen, setRemovePDFModalOpen] = useState(false);
  const [idToRemove, setIdToRemove] = useState(false);
  const [titleToRemove, setTitleToRemove] = useState(false);
  const [pdfIdEdit, setPdfIdEdit] = useState("");
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [tipoDoc, setTipoDoc] = useState([]);
  const [filesPDF, setFilesPDF] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisibleEdit, setIsVisibleEdit] = useState(false);
  const [pageSize, setPageSize] = useState(12);  
  const [current, setCurrent] = useState(1);


  useEffect(() => {
    fetch(`https://api.spap.pt/api/all-estatutos-docs`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar eventos");
        }
        return response.json();
      })
      .then((data) => {
        if (data.length === 0) {
          console.log("nenhum evento");
        }
        setFilesPDF(() => getFilesPDF(data.estatutosdocs));
      })
      .catch((error) => console.error(error));
  }, []);

  notification.config({
    placement: "bottomRight",
    bottom: 10,
    duration: 5,
    rtl: false,
  });

  const clickToPDFDrawer = (item) => {
    setPdfIdEdit(item.id);
    setDescricaoPDFEdit(item.descricao);
    setTituloPDFEdit(item.titulo);
    setPDFFileEdit(item.url);
    setTipoDocEdit(item.tipo_doc);
    setIsVisibleEdit(item.visible);
    setShowPDFDrawer(true);
  };

  const propPDF = {
    onRemove: (file) => {
      const index = fileUploadList.indexOf(file);
      const newFileList = fileUploadList.slice();
      newFileList.splice(index, 1);
      setFileUploadList(newFileList);
    },
    beforeUpload: (file) => {
      setFileUploadList([...fileUploadList, file]);
      return false;
    },
    fileUploadList,
  };

  const getFilesPDF = (files) => {
    if (!files) {
      return [];
    }
    if (!files.length) {
      return [];
    }

    let myFiles = files.filter((file) => {
      if (file != null) {
        let date = file.updated_at.substring(0, 10);
        let [year, month, day] = date.split("-");
        file.dataToShow = day + "/" + month + "/" + year;

        return file;
      }
    });

    let tiposDocsToShow = [];
    myFiles?.map((estatutosdoc) => {
      tiposDocsToShow.push(estatutosdoc.tipo_doc);
    });

    let uniqueArray = tiposDocsToShow.filter((value, index) => {
      const _value = JSON.stringify(value);
      return (
        index ===
        tiposDocsToShow.findIndex((obj) => {
          return JSON.stringify(obj) === _value;
        })
      );
    });

    setItems(uniqueArray);

    return myFiles.sort(function(a, b) {
      return b.id - a.id;
    });
  };

  const handleSubmitPDF = (e) => {
    if (
      !fileUploadList.length ||
      !tituloPDF.length ||
      !descricaoPDF.length ||
      !tipoDoc.length
    ) {
      notification.error({
        description:
          "Para guardar um novo documento, preencha todos os campos e faça o upload do ficheiro.",
      });
      return;
    }

    const formData = new FormData();

    formData.append("titulo", tituloPDF);
    formData.append("file", fileUploadList[0]);
    formData.append("descricao", descricaoPDF);
    formData.append("tipo_doc", tipoDoc);
    formData.append("visible", isVisible ? 1 : 0);

    // You can use any AJAX library you like
    fetch("https://api.spap.pt/api/admin/store-estatuto-doc", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    }).then((response) => {
      response
        .json()
        .then((data) => {
          if (data.message == "already_exists") {
            notification.error({
              description: "Erro ao submeter o ficheiro! Tente novamente.",
            });
            return;
          }
          setFileUploadList([]);
          setTituloPDF("");
          setDescricaoPDF("");
          setTipoDoc([]);
          setFilesPDF(() => getFilesPDF(data.ficheiros));
          notification.success({
            description: "O ficheiro foi submetido com sucesso!",
          });
        })
        .catch((err) => {});
    });
  };

  const [currentItemsPDF, setCurrentItemsPDF] = useState(filesPDF.slice(0, 8));
  const [itemOffsetPDF, setItemOffsetPDF] = useState(0);
  const itemsPerPagePDF = 18;

  const handlePagePDF = (page, newPageSize) => {
    setCurrent(page);
    setPageSize(newPageSize);
  };


  useEffect(() => {
    const endOffset = itemOffsetPDF + itemsPerPagePDF;

    setCurrentItemsPDF(filesPDF.slice(itemOffsetPDF, endOffset));
  }, [itemOffsetPDF, filesPDF]);

  const openRemovePDFModal = (id, titulo) => {
    setIdToRemove(id);
    setTitleToRemove(titulo);
    setRemovePDFModalOpen(true);
  };

  const handleRemoveFile = (e) => {
    axios
      .post(
        "https://api.spap.pt/api/admin/remove-estatuto-doc",
        { idToRemove },
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + session_storage.token,
          },
        }
      )
      .then((res) => {
        setIdToRemove("");
        setRemovePDFModalOpen(false);
        if (res.status == 200) {
          setFilesPDF(() => getFilesPDF(res.data.ficheiros));
          notification.success({
            description: "O Documento foi removido com sucesso!",
          });
        }
      })
      .catch((error) => {
        // notification.error({description: 'Erro ao remover a imagem da galeria! Tente novamente.'});
      });
  };

  const handleEditPDF = () => {
    if (
      !tituloPDFEdit.length ||
      !descricaoPDFEdit.length ||
      !tipoDocEdit.length
    ) {
      notification.error({
        description: "Para editar o Documento, preencha os campos respetivos.",
      });
      return;
    }

    const formData = new FormData();

    if (fileUploadList.length) {
      formData.append("file", fileUploadList[0]);
    }

    formData.append("fileId", pdfIdEdit);
    formData.append("titulo", tituloPDFEdit);
    formData.append("descricao", descricaoPDFEdit);
    formData.append("visible", isVisibleEdit ? 1 : 0);
    formData.append("tipo_doc", tipoDocEdit);

    // You can use any AJAX library you like
    fetch("https://api.spap.pt/api/admin/update-estatuto-doc", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    }).then((response) => {
      response
        .json()
        .then((data) => {
          if (data.message == "already_exists") {
            notification.error({
              description: "Erro ao submeter o ficheiro! Tente novamente.",
            });
            return;
          }
          setShowPDFDrawer(false);
          setFilesPDF(() => getFilesPDF(data.ficheiros));
          notification.success({
            description: "O ficheiro foi submetido com sucesso!",
          });
        })
        .catch((err) => {});
    });
  };

  const inputRef = useRef(null);
  const onNameChange = (event) => {
    setName(event.target.value);
  };
  const addItem = (e) => {
    e.preventDefault();
    setItems([...items, name || `New item ${index++}`]);
    setName("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };


  const handleSearch = (value) => {
    setCurrent(1);
    setSearchTerm(value.toLowerCase());
  };

  const filteredDocs = filesPDF.filter((file) =>
    file.titulo.toLowerCase().includes(searchTerm) ||
    file.descricao.toLowerCase().includes(searchTerm)
  );


  const startIndex = (current - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentData = filteredDocs.slice(startIndex, endIndex);

  return (
    <Wrapper>
      <div>
        <Sidebar />
      </div>
      <Content>
        <Header />

        { showForm == false && 
          <ContentHeader className="mb-10">
            <Title>Estatutos e Documentos</Title>
            <Col align="right" span={24}>

              <Space size={28}>
                  <Search
                    className="back-input"
                    style={{ width: "500px"}}
                    placeholder="Procurar..."
                    onSearch={(e) => handleSearch(e.target.value)}
                    onChange={(e) => handleSearch(e.target.value)}
                    enterButton
                  />
                  <Button
                    onClick={() => setShowForm(true)}
                    style={{
                      background: "#494D7D",
                      color: "#fff",
                      borderRadius: "6px",
                      height: "45px",
                      display: "flex",
                      fontWeight: "bold",
                      alignItems: "center",
                      padding: "0 30px",
                    }}
                  >
                    <PlusOutlined /> Novo documento
                  </Button>
                  </Space>
            </Col>
          </ContentHeader>
        }

        <Row align={"left"} style={{ marginBottom: "10px" }} gutter={[8, 8]}>
          { showForm == true && 
          <Col span={24}>
            <Card
              className="form"
              style={{ position: "sticky !important", top: "100px" }}
            >
                <CardHeader>
                  <Row className="w-100">
                    <Col span={20}>
                      <Title>Estatutos e Documentos</Title>                                      
                      <p className="text">
                        Faça upload de documento(s) aqui para poder utilizar em todo a plataforma
                      </p>
                    </Col>
                    <Col span={4} align="right">
                      <Space size={20}
                        className="justify-end"
                        align={'middle'}
                      >
                            <Space>
                              <span className="regular-text">Visivel na plataforma</span>
                              {isVisible == 1 || isVisible == true ? (
                                <>
                                  {" "}
                                  <Switch
                                    checked
                                    onChange={(e) => setIsVisible(e)}
                                  />
                                </>
                              ) : (
                                <>
                                  <Switch onChange={(e) => setIsVisible(e)} />
                                </>
                              )}
                            </Space>
                      </Space>
                    </Col>
                  </Row>
                </CardHeader>
                <Divider style={{ margin: "12px 0" }}/>
                <Row gutter={[10,8]}>
                <Col span={8}>
                <label className="text">Tipo de Documento</label>
                <Select
                  required
                  style={{
                    width: 300,
                    marginBottom: "10px",
                  }}
                  value={tipoDoc}
                  onChange={(e) => setTipoDoc(e)}
                  placeholder="Tipo de documento"
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <Divider
                        style={{
                          margin: "8px 0",
                        }}
                      />
                      <Space
                        style={{
                          padding: "0 8px 4px",
                        }}
                      >
                        <Input
                          placeholder="Inserir novo"
                          ref={inputRef}
                          value={name}
                          onChange={onNameChange}
                        />
                        <Button
                          type="text"
                          icon={<PlusOutlined />}
                          onClick={addItem}
                        >
                          Adicionar
                        </Button>
                      </Space>
                    </>
                  )}
                  options={items.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                />
                </Col>
                <Col span={16}>
                <label className="text">Título</label>
                <Input
                  key={"titulo_pdf"}
                  style={styles.input_class}
                  name="titulo_pdf"
                  placeholder="Título do PDF"
                  value={tituloPDF}
                  onChange={(e) => setTituloPDF(e.target.value)}
                />
                </Col>
                <Col span={8}>
                  <label className="text">Upload (máx. 2MB)</label>
                  <Dragger
                    {...propPDF}
                    fileList={[...fileUploadList]}
                    key={"dragger-pdf"}
                  >
                    <p className="ant-upload-text text mb-0">
                      Upload de novo ficheiro
                    </p>
                    <p className="ant-upload-hint mb-0">Faça Drag and drop aqui</p>
                  </Dragger>
                </Col>
                <Col span={16}>
                  <label className="text">Descrição</label>
                  <TextArea
                    key={"descricao_pdf"}
                    name="descricao_pdf"
                    placeholder="Descrição do PDF"
                    className="textarea-input"
                    rows={5}
                    value={descricaoPDF}
                    onChange={(e) => setDescricaoPDF(e.target.value)}
                  />
                </Col>
                    <Divider style={{ margin: "12px 0" }}/>
                  <Col span={24} align="right">
                    <Space size={10}>
                      <Button
                        onClick={() => setShowForm(false)}
                        className="close-btn hide-event"
                      >
                        Fechar
                      </Button>
                      <Button
                        type="primary"
                        className="cta publish"
                        onClick={handleSubmitPDF}
                        align="end"
                      >
                        Publicar <IconOk className="icon icon-ok" />
                      </Button>
                    </Space>
                  </Col>
                </Row>
            </Card>
          </Col>
          }
          <Col span={24}>
            {filteredDocs.length > 0 && (
              <Space direction="vertical" style={{ width: "100%" }}>
                <GridCards>
                  {currentData.map((item, index) => {
                    return (
                      <Card
                        className={
                          item.status == 0
                            ? "item disabled item-" + index
                            : "item item-" + index
                        }
                        key={"ficheiros-" + item.id}
                      >
                        <Space direction="vertical" className="w-100 space-between">
                        <div>
                        <CardHeader>
                          <Title className="item__title">{item.titulo}</Title>
                          <IconClose
                            className="icon icon-close"
                            onClick={() =>
                              openRemovePDFModal(item.id, item.titulo)
                            }
                          />
                        </CardHeader>
                          <p className="item__text">{item.descricao}</p>
                        </div>

                          <Space
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              alignContent: "center",
                            }}
                          >
                            <Space size={10}>
                              <Space size={2}>
                                <IconCalendar className="icon icon-calendar" />
                                <span className="text">{item.dataToShow}</span>
                              </Space>
                              <Space
                                className="action-edit"
                                size={2}
                                onClick={() => clickToPDFDrawer(item)}
                              >
                                <IconEdit className="icon icon-edit" />
                                <span>Editar</span>
                              </Space>

                                {item.visible == 1 &&
                                <Tag color= 'green'>Ficheiro visivel</Tag>}
                                {item.visible == 0 &&
                                <Tag color='blue'>Ficheiro oculto</Tag>}
                            </Space>
                            <div>
                              <Space className="action-edit">
                                <a
                                  target="_blank"
                                  href={
                                    "https://api.spap.pt/estatutosdocs/" +
                                    item.id +
                                    "/" +
                                    item.url
                                  }
                                >
                                  <EyeOutlined
                                    style={{ paddingRight: "5px" }}
                                  />
                                </a>
                              </Space>
                            </div>
                          </Space>
                        </Space>
                      </Card>
                    );
                  })}
                </GridCards>
                <ContentFooter>
                  <Pagination
                    defaultCurrent={1}
                    total={filesPDF.length}
                    pageSize={pageSize}
                    onChange={handlePagePDF}
                    showSizeChanger
                    pageSizeOptions={["12", "25", "50", "100"]}
                    locale={{
                      items_per_page: " / página",
                      jump_to: "Ir para",
                      page: "página",
                    }}
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} de ${total} itens`
                    }
                  />
                </ContentFooter>
              </Space>
            )}
          </Col>
        </Row>

        <Divider />
        <Footer />
      </Content>
      <Modal
        key={"remove-file-" + idToRemove}
        title="Está prestes a eliminar um ficheiro"
        open={removePDFModalOpen}
        onOk={handleRemoveFile}
        onCancel={() => setRemovePDFModalOpen(false)}
        okText="Confirmar"
        cancelText="Cancelar"
      >
        <p>
          Tem a certeza que pretende remover o ficheiro <b>'{titleToRemove}'</b>
          ?
        </p>
      </Modal>
      <Drawer
        key={"editar-pdf-" + pdfIdEdit}
        title="Editar Documento"
        width={600}
        onClose={() => setShowPDFDrawer(false)}
        open={showPDFDrawer}
        bodyStyle={{
          paddingBottom: 80,
        }}
        className="edit-post-form"
        extra={
          <Space>
            <Button onClick={setShowPDFDrawer}>Cancelar</Button>
            <Button
              onClick={handleEditPDF}
              type="submit"
              style={{
                borderRadius: "6px",
                background: "#494D7D",
                color: "#fff",
              }}
            >
              Guardar
            </Button>
          </Space>
        }
      >
        <form layout="vertical" id="update-event-form">
          <Col>
            <Space>
              <span className="regular-text">Visivel na plataforma</span>
              {isVisibleEdit == 1 || isVisibleEdit == true ? (
                <>
                  {" "}
                  <Switch
                    checked
                    onChange={(e) => setIsVisibleEdit(e)}
                  />
                </>
              ) : (
                <>
                  <Switch onChange={(e) => setIsVisibleEdit(e)} />
                </>
              )}
            </Space>
            <Divider style={{ margin: "12px 0" }}/>
            <Col span={24}>
              <h5
                style={{
                  marginBottom: "10px",
                  fontSize: "18px",
                  textAlign: "center",
                }}
              >
                Visualizar o ficheiro
              </h5>
              <p style={{ textAlign: "center", marginBottom: "1%" }}>
                <a
                  href={
                    "https://api.spap.pt/estatutosdocs/" +
                    pdfIdEdit +
                    "/" +
                    pdfFileEdit
                  }
                  target="_blank"
                >
                  <IconUpload />
                </a>
              </p>
              <p style={{ textAlign: "center" }}>{pdfFileEdit}</p>
            </Col>
            <Col span={24}>
              <Dragger
                key={"dragger-pdf" + pdfIdEdit}
                {...propPDF}
                style={{ marginBottom: "5px", width: "100%" }}
              >
                <div>
                  <p className="ant-upload-drag-icon">
                    <IconUpload />
                  </p>
                  <p className="ant-upload-text text">
                    Upload do novo Ficheiro{" "}
                  </p>
                  <p className="ant-upload-hint">
                    Se pretende atualizar o ficheiro, faça drag and drop ou
                    clique nesta caixa.
                  </p>
                </div>
              </Dragger>
            </Col>
            <Divider style={{ background: "#fff", margin: "12px 0" }}></Divider>
            <Row
              className="row-drawer"
              gutter={[8, 8]}
              style={{ flexFlow: "column !important" }}
            >
              <label className="text">Tipo</label>
              <Col span={24}>
                <Select
                  required
                  style={{
                    width: 300,
                  }}
                  value={tipoDocEdit}
                  onChange={(e) => setTipoDocEdit(e)}
                  placeholder="Tipo de documento"
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <Divider
                        style={{
                          margin: "8px 0",
                        }}
                      />
                      <Space
                        style={{
                          padding: "0 8px 4px",
                        }}
                      >
                        <Input
                          placeholder="Inserir novo"
                          ref={inputRef}
                          value={name}
                          onChange={onNameChange}
                        />
                        <Button
                          type="text"
                          icon={<PlusOutlined />}
                          onClick={addItem}
                        >
                          Adicionar
                        </Button>
                      </Space>
                    </>
                  )}
                  options={items.map((item) => ({
                    label: item,
                    value: item,
                  }))}
                />
              </Col>
              <Col span={24}>
                <h6 style={styles.h6_label}>Título</h6>
                <Input
                  key={"titulo-pdf" + pdfIdEdit}
                  placeholder="Título"
                  name="titulo"
                  style={styles.input_class}
                  defaultValue={tituloPDFEdit}
                  onChange={(e) => setTituloPDFEdit(e.target.value)}
                  required
                />
              </Col>
              <Col span={24}>
                <h6 style={styles.h6_label}>Descrição</h6>
                <TextArea
                  key={"descricao-pdf" + pdfIdEdit}
                  name="descricao_pdf"
                  placeholder="Descrição do PDF"
                  className="textarea-input"
                  rows={5}
                  value={descricaoPDFEdit}
                  onChange={(e) => setDescricaoPDFEdit(e.target.value)}
                />
              </Col>
            </Row>
          </Col>
        </form>
      </Drawer>
    </Wrapper>
  );
}
